import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Add16 = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.375 8H13.625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2.375V13.625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
